import * as React from 'react';
import { TooltipHost, Dropdown, IDropdownOption, getTheme } from '@fluentui/react';
import { AdminContext } from 'Store/Admin';
import { settingsDropdownRoleStyles } from '../SettingsStyles';

export interface ConfigDropdownProps {
  id: string;
  label: string;
  options: IDropdownOption[];
  tooltip: string;
  className: string;
}

export const ConfigDropdown: React.FC<ConfigDropdownProps> = props => {
  const { palette, fonts } = getTheme();
  const { state, dispatch } = React.useContext(AdminContext);

  const onComponentChange = (newValue?: IDropdownOption<any>): void => {
    if (newValue) {
      dispatch({
        type: 'DEFAULT_CASE_COMPARER_ALGORITHM',
        payload: newValue.key as string
      });
      dispatch({
        type: 'IS_UPDATED',
        payload: true
      });
    }
  };

  return (
    <TooltipHost content={props.tooltip}>
      {state.queueDataState && (
        <Dropdown
          className={props.className}
          id={props.id}
          label={props.label}
          selectedKey={state.queueDataState.defaultCaseComparerAlgorithm}
          options={props.options}
          onChange={(e, newValue): void => onComponentChange(newValue)}
          styles={settingsDropdownRoleStyles(palette, fonts, 170)}
        />
      )}
    </TooltipHost>
  );
};
